import React from "react";
import IndustryComparison from "./IndustryComparison";

const UseCasesByIndustry = ({ data }) => {
    if (!data) return null;

    return (
        <div className="keyDifference">
            <h4 className="title">{data?.title}</h4>
            {data?.paragraph?.map((para, paraIndex) => {
                return (
                    <div key={paraIndex}>
                        <p className="paragraph">{para?.para}</p>
                        <IndustryComparison data={para} />
                    </div>
                )
            })}
        </div>
    );
};

export default UseCasesByIndustry;